import { Helmet } from "react-helmet";
import { Container } from "reactstrap";

import { PageTitles } from "constants";
import AddFeedbackForm from "./AddFeedbackForm";

export default function AddFeedbackFormDetails() {
    return (
        <div className="page-content">
            <Helmet>
                <title>{PageTitles.ADD_FEEDBACK_FORM}</title>
            </Helmet>
            <Container fluid className="customer-details">
                <AddFeedbackForm />
            </Container>
        </div>
    );
}
